import { NzI18nInterface, ro_RO } from 'ng-zorro-antd/i18n';

// Patch for Romanian locale to include missing DatePicker translations
export const ro_RO_patched: NzI18nInterface = {
  ...ro_RO,
  DatePicker: {
    ...ro_RO.DatePicker,
    lang: {
      ...ro_RO.DatePicker.lang,
      yearPlaceholder: 'An',
      quarterPlaceholder: 'Trimestru',
      monthPlaceholder: 'Lună',
      weekPlaceholder: 'Săptămână',
      rangeYearPlaceholder: ['An început', 'An sfârșit'],
      rangeQuarterPlaceholder: ['Trimestru început', 'Trimestru sfârșit'],
      rangeMonthPlaceholder: ['Lună început', 'Lună sfârșit'],
      rangeWeekPlaceholder: ['Săptămână început', 'Săptămână sfârșit'],
    },
  },
};
